import React from 'react';
import Logo from 'fitbeat.react-native-components/assets/images/logo-black.png';

export const AuthTitleBar = ({ header }) => (
    <div className='menu-container auth-menu'>
        <div className='title-bar clearfix'>
            <div className='auth-logo float-left small-4 large-offset-1'>
            <a href='http://fitillion.com'>
                <img src={Logo} />
            </a>
            </div>
            <div className='float-right text-right small-4 end hide-for-small-only'>
                <a className='home-link' href='http://fitillion.com'>Home</a>
            </div>
            <div className='float-right small-5 show-for-small-only mobile-header'>
                <a className='home-link'>{header}</a>
            </div>
            <div className='float-right small-4 show-for-small-only'></div>
        </div>
    </div>
);
